import { Component, type ReactNode } from 'react';

/** Installed apps can outlive a deployment; failed imports need a recoverable screen. */
export default class PageLoadBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (!this.state.failed) return this.props.children;
    return <main className="surface" style={{ display: 'grid', placeItems: 'center', padding: 24 }}>
      <section className="card" role="alert" style={{ width: 'min(440px, 100%)' }}>
        <h1>Não foi possível abrir esta página</h1>
        <p>Verifique a ligação ao servidor e volte a carregar a app.</p>
        <button type="button" className="btn accent" onClick={() => window.location.reload()}>Voltar a carregar</button>
      </section>
    </main>;
  }
}
